import cs from 'classnames';
import { CommentLineIcon } from 'ui';
import { DirectMessageButton } from '../direct-message-button';

const IconDirectMessageButton = ({
  legacyUserId,
  small = false,
  type = 'link-secondary',
}: {
  legacyUserId: string;
  small?: boolean;
  type?: 'link-secondary' | 'tertiary' | 'text';
}) => (
  <DirectMessageButton
    className={cs('icon-direct-message-button', { 'icon-direct-message-button--small': small })}
    icon={<CommentLineIcon />}
    legacyUserId={legacyUserId}
    type={type}
  />
);

export default IconDirectMessageButton;
